import { DIMENSIONS, FIT_LABELS, JOB, MATCH_SCORE, fitOf } from '../../content'
import { anim, prog, stagger } from '../../motion'
import { BeamBands, Count, FitIcon } from '../../primitives'
import { Line } from '../kit'

// Eine riesige Zahl, die dann zur Seite rückt und ihre Begründung freigibt.
// Stufen wie in der Legende des Passungsprofils (71 bis 100 hoch, 41 bis 70 mittel).
const SCORE_LABEL =
  MATCH_SCORE > 70
    ? FIT_LABELS.high
    : MATCH_SCORE > 40
      ? FIT_LABELS.mid
      : FIT_LABELS.low

export default function CinScore() {
  const hits = DIMENSIONS.filter((d) => fitOf(d) === 'high').length

  return (
    <div className='cin-full'>
      <div className='cin-score' style={prog([0.38, 0.52])}>
        <Line at={[0, 0.08]} out={[0.38, 0.46]} y={20} className='cin-eyebrow'>
          Passung für {JOB}
        </Line>
        <div
          className='cin-score__num'
          style={anim({ at: [0, 0.06], s: 0.8, y: 0 })}
        >
          <Count to={MATCH_SCORE} at={[0.04, 0.32]} suffix={' %'} />
        </div>
        <Line at={[0.5, 0.58]} y={20} className='cin-score__sub'>
          {SCORE_LABEL} · {hits} von {DIMENSIONS.length} im Idealbereich
        </Line>
      </div>

      <div className='cin-reasons'>
        <Line at={[0.48, 0.56]} className='cin-title cin-title--sm'>
          Jede Zahl hat einen Grund.
        </Line>
        {DIMENSIONS.map((d, row) => {
          return (
            <div
              key={d.name}
              className='cin-reason'
              style={anim({ at: stagger(0.52, 0.03, 0.08, row), x: 60, y: 0 })}
            >
              <div className='cin-reason__label'>{d.name}</div>
              <div className='cin-reason__track'>
                <BeamBands ideal={d.ideal} trans={d.trans} />
                <div
                  className='cin-reason__pin'
                  style={{
                    ...prog(stagger(0.6, 0.03, 0.1, row)),
                    left: `calc(var(--p) * ${d.lena}%)`
                  }}
                >
                  <div className='cin-reason__marker' />
                </div>
              </div>
              <div
                className='cin-reason__state'
                style={anim({
                  at: stagger(0.7, 0.03, 0.06, row),
                  s: 0.3,
                  y: 0
                })}
              >
                <FitIcon fit={fitOf(d)} size={26} />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
